package dev.lingvo.ops.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Text

val OpsWorkspaceNavStyle = CssStyle.base {
    Modifier.styleModifier {
        property("display", "flex")
        property("flex-wrap", "wrap")
        property("gap", "4px")
        property("min-width", "0")
    }
}

@Composable
fun OpsWorkspaceNav(orgId: String, current: String) {
    Nav(OpsWorkspaceNavStyle.toModifier().toAttrs { attr("aria-label", "Workspace sections") }) {
        listOf("" to "Overview", "/providers" to "Providers", "/billing" to "Billing", "/audit" to "Audit").forEach { (suffix, label) ->
            Link(path = "/workspaces/$orgId$suffix", modifier = OpsNavItemStyle.toModifier()
                .then(if (current == label) Modifier.attr("aria-current", "page") else Modifier)) { Text(label) }
        }
    }
}
